import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { userAppData } from '../MainApp.js';
import Header from '../common/header.js';
import { FaTools } from 'react-icons/fa';
import '../sysManager/SysManagerDesktop.css';
import '../sysManager/SysManagerMobile.css';
import './Tools.css';
import { TOOL_REGISTRY } from './toolRegistry.js';

/** Shows the Tools landing page only while the caller has module access. */
export default function ToolsHome() {
    if (Number(userAppData?.toolsData?.perms ?? 0) !== 1) {
        return <Navigate to='/app' replace />;
    }

    // Only registered implementations with a validated individual grant become launch links.
    const tools = (userAppData.toolsData.tools || []).filter(tool => Object.prototype.hasOwnProperty.call(TOOL_REGISTRY, tool.guid) && userAppData.toolsData.allowedTools?.includes(tool.guid));
    return (
        <div className='main_div'>
            <div className='internal_main_div sysManager_home_container tools-home'>
                <Header title='Tools' subtitle='Choose a tool to get started.' />
                {tools.length ? <ul className='tools-catalogue' aria-label='School tools'>
                    {tools.map(tool => {
                        // Share each tool's registered icon with its administration card.
                        const registeredTool = TOOL_REGISTRY[tool.guid];
                        const ToolIcon = registeredTool.icon || FaTools;
                        return <li key={tool.guid}>
                            <Link className='tools-catalogue-card' to={registeredTool.path}>
                                <ToolIcon className='tools-catalogue-icon' aria-hidden='true' />
                                <span className='tools-catalogue-copy'>
                                    <span className='tools-catalogue-name'>{tool.name}</span>
                                    <span className='tools-catalogue-description'>{registeredTool.description}</span>
                                </span>
                            </Link>
                        </li>;
                    })}
                </ul> : <p className='tools-empty'>No tools are currently assigned to you. Contact your school administrator for access.</p>}
            </div>
        </div>
    );
}
